import { useCallback } from "react";
import axiosInstance from "../../service/axiosInstance";
import { multiCurrencyAPI } from "../../service/api";
import { POST } from "../constants";
import { ICurrency } from "../../interfaces/multiCurrencyInterface";

const useCurrencies = () => {
  const getCurrenciesByIds = useCallback(async (currencyIds: number[]) => {
    try {
      const response = await axiosInstance.request({
        url: multiCurrencyAPI.GET_CURRENCY_BY_IDS,
        method: POST,
        data: currencyIds
      });
      return response.data as ICurrency[];
    } catch (error) {
      console.log('GET CURRENCIES BY IDS ERROR: ', error);
      return [];
    }
  }, []);

  const getCurrencyOptions = useCallback(async (currencyIds: number[]) => {
    return await getCurrenciesByIds(currencyIds);
  }, [])

  const selectCurrencyByParameter = useCallback((currencyId: number, currencies: ICurrency[]) => {
    const currencyOnParameter = currencies.find(currency => currency.recordId === currencyId);
    const selected = currencyOnParameter ?? null;
    return selected;
  }, [])

  return {
    getCurrenciesByIds,
    getCurrencyOptions,
    selectCurrencyByParameter,
  };
};

export default useCurrencies;
